/* Banana Manor product page behaviour: price disclosure, save without login, sticky buy bar.

   Aimed at one number. Over 90 days Meta sent 266 add-to-carts and 18 purchases, so the
   loss is after the button, on a $2,000 one-of-one that cannot be compared against a
   second identical unit. Saving gives an exit that is not the back button, the disclosure
   answers "why is this cheaper than the gallery" at the moment of doubt, and the sticky
   bar means the buy box is never more than a thumb away on a long page. */
(function () {
  var SAVE_KEY = 'bm_saved';

  function read() {
    try { return JSON.parse(localStorage.getItem(SAVE_KEY) || '[]'); } catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(SAVE_KEY, JSON.stringify(list)); } catch (e) {}
  }

  function toast(msg) {
    var t = document.querySelector('.bm-toast');
    if (!t) { t = document.createElement('div'); t.className = 'bm-toast'; document.body.appendChild(t); }
    t.textContent = msg;
    t.classList.add('is-on');
    clearTimeout(t._h);
    t._h = setTimeout(function () { t.classList.remove('is-on'); }, 3200);
  }

  function initDisclosure(root) {
    var btn = root.querySelector('.bm-why'), body = root.querySelector('.bm-whybody');
    if (!btn || !body) return;
    var open = btn.textContent.trim();
    btn.addEventListener('click', function () {
      var on = body.classList.toggle('is-on');
      btn.setAttribute('aria-expanded', on ? 'true' : 'false');
      btn.textContent = on ? 'Hide' : open;
    });
  }

  function initSave(root) {
    var btn = root.querySelector('.bm-save');
    if (!btn) return;
    var handle = btn.getAttribute('data-handle');
    if (!handle) return;
    var label = btn.querySelector('span');
    function paint() {
      var on = read().indexOf(handle) > -1;
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (label) label.textContent = on ? 'Saved' : (btn.getAttribute('data-label') || 'Save this rug');
    }
    btn.addEventListener('click', function () {
      var list = read(), i = list.indexOf(handle);
      if (i > -1) { list.splice(i, 1); write(list); paint(); toast('Removed from your saved rugs.'); }
      else {
        list.push(handle); write(list); paint();
        toast('Saved. It will be here when you come back, no account needed.');
      }
    });
    paint();
  }

  /* The sticky bar mirrors the real form rather than posting its own, so there is one
     add-to-cart path and Wholesale Gorilla only has to know about one button. */
  function initSticky() {
    var bar = document.querySelector('.bm-sticky');
    if (!bar) return;
    var realForm = document.querySelector('form[action*="/cart/add"]:not([id*="installment"])');
    var realBtn = realForm ? realForm.querySelector('[type=submit]') : null;
    var btn = bar.querySelector('button');
    if (btn) {
      if (!realBtn) { btn.style.display = 'none'; }
      else btn.addEventListener('click', function () { realBtn.click(); });
    }
    var anchor = realBtn || realForm;
    if (!anchor || !('IntersectionObserver' in window)) return;
    if (window.__bmStickyIO) window.__bmStickyIO.disconnect();
    window.__bmStickyIO = new IntersectionObserver(function (entries) {
      var e = entries[0];
      bar.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0);
    }, { threshold: 0 });
    window.__bmStickyIO.observe(anchor);
  }

  function boot() {
    document.querySelectorAll('.bm-pdp').forEach(function (root) {
      if (root.dataset.bmReady) return;
      root.dataset.bmReady = '1';
      initDisclosure(root);
      initSave(root);
    });
    initSticky();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
}());
